(function () {

  const article = document.querySelector('.article-content-main');

  if (!article) return;


  // =========================================
  // Find all H2 headings
  // =========================================

  const headings = article.querySelectorAll('h2');

  if (!headings.length) return;


  // =========================================
  // Create TOC
  // =========================================

  const tocWrapper = document.createElement('div');
  tocWrapper.className = 'article-toc-wrapper';


  // TOC title
  const tocTitle = document.createElement('p');
  tocTitle.className = 'article-toc-title';
  tocTitle.textContent = 'On this page';


  // TOC list
  const tocList = document.createElement('ul');
  tocList.className = 'article-toc-list';


  // Store TOC links
  const tocLinks = [];


  headings.forEach(function (heading, index) {

    // Create unique ID
    const headingId = 'article-section-' + (index + 1);

    heading.id = headingId;


    // Create list item
    const item = document.createElement('li');
    item.className = 'article-toc-item';


    // Create cat icon
    const dot = document.createElement('span');

    dot.className = 'article-toc-dot';

    dot.setAttribute('aria-hidden', 'true');

    dot.innerHTML = `
      <svg class="cat-icon"
        viewBox="0 0 275.432 204.114"
        xmlns="http://www.w3.org/2000/svg">

        <path
          fill="currentColor"
          d="m85.09 191.53c-9.639-12.84-11.672-16.17-10.498-32.44 1.538-21.3 1.024-21.3-27.811 0.04-13.26 9.82-15.87 14.6-14.196 26 1.62 11.03 0.188 13.97-6.822 13.97-15.075 0-11.852-33.03 5.248-53.77 7.766-9.42 9.417-22.24 13.333-33.05 5.335-14.729 8.15-26.754 7.036-30.191-6.147-18.961-6.688-27.537-20.197-47.293-21.334-31.199-34.368-29.313-30.509-33.972s25.619 11.278 35.709 26.526c10.09 15.249 17.636 31.58 27.497 36.858 9.862 5.277 96.89 22.977 130.06 11.147 14.09-5.026 32.01-12.343 47.8-10.56 8.63 0.974 14.68-15.681 18.12-12.668 2.73 2.393-4.93 8.999 10.32 20.788 4.21 3.259 5.42 9.542 5.23 14.562-0.63 17.253-10.46 11.468-23.68 11.468-9.89 0-32.42 13.725-31.94 27.835 0.21 6.11 3.91 24.07 11.33 37.55 4.88 8.85 8.35 17.45 11.25 22.69 4.56 8.26 8.22 9.75-1.26 12.08-2.16 0.52-6.84-5.24-10.27-11.64-3.42-6.4-14.58-29.08-22.33-34.81-12.81-9.47-11.03-9.67-13.89-2.22-1.73 4.51-2.14 27.19 0.74 34.81 4.21 11.17 6.1 13.86-1.63 13.86-3.78 0-6.87-4.33-6.87-9.62 0-5.28-3.91-18.25-7.81-29.14-4.31-12.02 1.82-14.64-7.81-19.52s-8.97 0.29-32.08 2.06c-23.11 1.76-30.11-0.98-39.38 12.05-13.218 18.56-12.685 24.64 3.31 37.74 8.6 7.04 8.31 11.45 3.63 11.45-11.584-0.01-15.274-4.12-21.63-12.59z"
        />

      </svg>
    `;


    // Create link
    const link = document.createElement('a');

    link.href = '#' + headingId;

    link.className = 'article-toc-link';

    link.textContent = heading.textContent.trim();


    // Store link for active state
    tocLinks.push({
      link: link,
      item: item,
      heading: heading
    });


    // =========================================
    // Smooth scrolling
    // =========================================

    link.addEventListener('click', function (event) {

      event.preventDefault();

      const target = document.getElementById(headingId);

      if (!target) return;

      const headerOffset = 115;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

    });


    // Add icon + link
    item.appendChild(dot);
    item.appendChild(link);

    // Add item
    tocList.appendChild(item);

  });


  // Add title + list
  tocWrapper.appendChild(tocTitle);
  tocWrapper.appendChild(tocList);


  // =========================================
  // Active TOC section
  // =========================================

  let currentActiveIndex = -1;


  function updateActiveToc() {

    const scrollPosition = window.pageYOffset + 500;

    let activeIndex = 0;


    // Find the last H2 that has passed the reading position
    headings.forEach(function (heading, index) {

      if (heading.offsetTop <= scrollPosition) {
        activeIndex = index;
      }

    });


    // Don't do anything if the active section hasn't changed
    if (activeIndex === currentActiveIndex) return;


    currentActiveIndex = activeIndex;


    // Remove active state from all items
    tocLinks.forEach(function (toc) {

      toc.item.classList.remove('active');

    });


    // Add active state
    const activeToc = tocLinks[activeIndex];

    if (!activeToc) return;

    activeToc.item.classList.add('active');


    // =========================================
    // Keep active item visible inside TOC
    // Desktop only
    // =========================================

    if (window.innerWidth >= 1280) {

      activeToc.item.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });

    }

  }


  // Update while scrolling
  let ticking = false;

  window.addEventListener('scroll', function () {

    if (!ticking) {

      window.requestAnimationFrame(function () {

        updateActiveToc();

        ticking = false;

      });

      ticking = true;

    }

  });


  // Initial active section
  updateActiveToc();


  // =========================================
  // Position TOC
  // =========================================

  const tocSidebar = document.querySelector('.article-toc-sidebar');

  const firstHeading = headings[0];
  const keyTakeaways = document.getElementById('iz-key-takeaways');


  // Mobile / Tablet:
  // Keep TOC inside article before first H2
  function moveTocToArticle() {

    if (!firstHeading || !firstHeading.parentNode) return;

    firstHeading.parentNode.insertBefore(
      tocWrapper,
      firstHeading
    );

  }


  // Desktop:
  // Move TOC to sidebar
  function moveTocToSidebar() {

    if (!tocSidebar) return;

    tocSidebar.appendChild(tocWrapper);

  }

  // =========================================
// Position Key Takeaways
// =========================================

function moveKeyTakeaways() {

  if (!keyTakeaways || !firstHeading || !firstHeading.parentNode) return;

   // =========================================
  // Desktop: 1280px and above
  // TOC is in sidebar
  //
  // Article order:
  // Content
  // Key Takeaways
  // First H2
  // =========================================

  if (window.innerWidth >= 1280) {

    firstHeading.parentNode.insertBefore(
      keyTakeaways,
      firstHeading
    );

    return;
  }


  // =========================================
  // iPad / Tablet + Mobile: below 1280px
  // TOC is inside article
  //
  // Article order:
  // Content
  // Key Takeaways
  // TOC
  // First H2
  // =========================================

  if (tocWrapper.parentNode) {

    tocWrapper.parentNode.insertBefore(
      keyTakeaways,
      tocWrapper
    );

  }

}



  // =========================================
  // Check screen size
  // =========================================

 function updateTocPosition() {

  if (window.innerWidth >= 1280) {

    // Desktop
    moveTocToSidebar();

  } else {

    // iPad + Mobile
    moveTocToArticle();

  }


  // Position Key Takeaways after TOC position is determined
  moveKeyTakeaways();

}



  // Initial position
  updateTocPosition();


  // =========================================
  // Handle resizing
  // =========================================

  let resizeTimer;

  window.addEventListener('resize', function () {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {

      updateTocPosition();

      updateActiveToc();

    }, 150);

  });


})();